import { getCatalog } from 'common/api/products';

import {
    FETCH_PRODUCTS,
    FETCH_PRODUCTS_FAILURE,
    FETCH_PRODUCTS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) => {
    dispatch(actions[FETCH_PRODUCTS]());

    getCatalog()
        .then((response) => {
            dispatch(actions[FETCH_PRODUCTS_SUCCESS](response.data.data));
        })
        .catch((error) =>
            dispatch(
                actions[FETCH_PRODUCTS_FAILURE](error?.response?.data?.errors),
            ),
        );
};
